<template>
  <div class="gameReportList">
		<div class="select">
      <a-select class="option" placeholder="筛选年级" style="width: 120px" @change="handleChangeGrade" allowClear>
        <a-select-option v-for="item in schoolGrades" :key="item" :value="item">{{item}}</a-select-option>
      </a-select>
      <a-select class="option" placeholder="筛选班级" style="width: 120px" @change="handleChangeClass" allowClear>
        <a-select-option v-for="item in classChangeList" :key="item" :value="item">{{item}}</a-select-option>
      </a-select>
      <a-input placeholder="学生姓名" v-model="stuName"/>
      <a-input placeholder="名称/描述/关键字" v-model="keyInfo"/>
      <a-button class="commit" type="primary" @click="searchHandle">查询</a-button>
    </div>
    <div class="reortTable">
      <a-table :columns="columns" :dataSource="personalInfo" :rowKey="row => row.ID" :pagination="{ pageSize: 10 }">
        <template slot="TITLE" slot-scope="text">{{text}}</template>
        <template slot="REAL_NAME" slot-scope="text">{{text}}</template>
        <template slot="SEX_V" slot-scope="text">{{text}}</template>
        <template slot="GRADE" slot-scope="text">{{text}}</template>
        <template slot="CLASS" slot-scope="text">{{text}}</template>
        <template slot="TIME" slot-scope="text">{{text}}</template>
        <template slot="operation" slot-scope="text, record">
          <a :href="getReportUrl(record)" target="_blank">查看报告</a>
        </template>
      </a-table>
    </div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import STUDENTFUN from '@/util/studentFun'
import GradeFormatTwo from '@/util/gradeFormatTwo'
import URL from '@/store/url'
import md5 from 'blueimp-md5'
export default {
	name: 'GameReportList',
	data () {
      return {
        columns: [
        {
          title: '任务名称',
          dataIndex: 'TITLE',
          key: 'TITLE',
          scopedSlots: { customRender: 'TITLE' }
        },
        {
          title: '姓名',
          dataIndex: 'REAL_NAME',
          key: 'REAL_NAME',
          scopedSlots: { customRender: 'REAL_NAME' }
        },
        {
          title: '性别',
          dataIndex: 'SEX_V',
          key: 'SEX_V',
          scopedSlots: { customRender: 'SEX_V' }
        },
        {
          title: '年级',
          dataIndex: 'GRADE',
          key: 'GRADE',
          scopedSlots: { customRender: 'GRADE' }
        },
        {
          title: '班级',
          dataIndex: 'CLASS',
          key: 'CLASS',
          scopedSlots: { customRender: 'CLASS' }
        },
        {
          title: '时间范围',
          dataIndex: 'TIMESCOPE',
          key: 'TIMESCOPE',
          scopedSlots: { customRender: 'TIMESCOPE' }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          key: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
        ],
        stuName: null,
        keyInfo: null,
        gradeVal: null,
        classArr: null,
        gradeClassAll: null,
        personalInfo: [],
        personalInfoAll: [],
      }
    },
    computed: {
      ...mapState([
        'teacherAdmin',
        'schoolGrades',
        'classReport',
        'gamePersonalReport'
      ]),
      classChangeList () {
        let list = null
        if (this.gradeVal) {
          this.gradeClassAll.classMaps.forEach((val, key) => {
            if (this.gradeVal === GradeFormatTwo(key)) {
              list = val
            }
          })
        } else {
          if (this.gradeClassAll) {
            list = this.gradeClassAll.classArr
          } 
        }
        return list
      }
    },
    methods: {
      ...mapActions([
        'getGamePersonalReport'
      ]),
      handleChangeGrade(value) {
        this.gradeVal = value
      },
      handleChangeClass(value) {
        this.classVal = value
      },
      getReportUrl(record){
        return `${URL.TO_GAME_PERSON_REPORT}?gamePlanId=${record.DQ_ID}&studentUid=${record.UID}&tokenValue=${md5(record.DQ_ID + 'AAA' + record.UID + 'BBB')}&token=${this.teacherAdmin.tokenValue}`
      },
      searchHandle(){
        this.personalInfo = this.personalInfoAll.filter((item) => !this.gradeVal ? true : item.GRADE === this.gradeVal).filter((item) => !this.classVal ? true : item.CLASS === this.classVal).filter((item) => !this.stuName ? true : item.REAL_NAME.indexOf(this.stuName) !== -1).filter((item) => !this.keyInfo ? true : item.TITLE.indexOf(this.keyInfo) !== -1)
      }
    },
    async mounted () {
			await this.getGamePersonalReport()
			console.log(this.gamePersonalReport)
      this.gamePersonalReport.map((item,index) =>{
        let info = {
          ID: index,
          UID: item.UID,
          DQ_ID: item.GAME_PLAN,
          TITLE: item.TITLE,
          REAL_NAME: item.REAL_NAME,
          SEX_V: item.SEX_V == '1' ? '男' : '女',
          GRADE: GradeFormatTwo(item.GRADE),
          CLASS: item.CLASS + '班',
          GRADE_ID: item.GRADE,
          CLASS_ID: item.CLASS,//.substring(0,item.CLASS.indexOf("班")),
          TIMESCOPE: item.STARTTIME.substring(0,10) + '  -  ' + item.ENDTIME.substring(0,10),
        }
        this.personalInfo.push(info)
        this.personalInfoAll.push(info)
      })
      this.gradeClassAll = STUDENTFUN.uploadClass(this.personalInfoAll)
    }
}
</script>

<style>
.gameReportList .select{
  display: flex;
  margin-bottom: 16px;
  margin-left: 16px;
}
.gameReportList .select .ant-btn-primary{
  width:64px;
  height:32px;
  background: rgba(81,191,148,1);
  border-radius: 4px;
  border-color: rgba(81,191,148,1);
}
.gameReportList .select .option{
  width: 120px;
  margin-right: 16px;
}
.gameReportList .select > input{
  width: 180px;
  height: 32px;
  margin-right: 14px;
}
.gameReportList .select .ant-btn > span {
  color: #ffffff;
}
</style>
